module.exports = __webpack_public_path__ + "static/bf_dungeon-b3d9bcd00f11d8fef2a619bde67f4ae9.webp";